import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getAppVersion } from "../api/services/clinic/version";
import { isLiffRoutePath } from "../utils/liffRoute";

const AppContext = createContext({
  appVersion: null,
  appVersionError: null,
});

export function AppProvider({ children }) {
  const [appVersion, setAppVersion] = useState(null);
  const [appVersionError, setAppVersionError] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const pathname = typeof window !== "undefined" ? window.location.pathname : "";
    const isLiffRoute = isLiffRoutePath(pathname);

    if (isLiffRoute) {
      setIsInitialized(true);
      return;
    }

    const fetchVersion = async () => {
      try {
        const versionData = await getAppVersion();
        setAppVersion(versionData ?? null);
        setAppVersionError(null);
      } catch (error) {
        console.error("Failed to fetch app version", error);
        setAppVersionError(error);
        setAppVersion(null);
      } finally {
        setIsInitialized(true);
      }
    };

    fetchVersion();
  }, []);

  const value = useMemo(
    () => ({
      appVersion,
      appVersionError,
      isInitialized,
    }),
    [appVersion, appVersionError, isInitialized]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
  return useContext(AppContext);
}
